import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAiAssistantProfileAttribute } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { fields, options } from './constants';

export const AIprofileSettings: React.FC<any> = (props) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const {
    aiAssistant: { profile }
  } = useSelector((state: any) => state.lomavisCreator);

  return (
    <div className={"d-flex h-100"}>
      <div className="col-12 d-flex flex-column">
        <div className="card p-4 d-flex flex-grow-1 flex-column">
          <h2>{t('lomavisCreator.aiAssistant.profileSettings')}</h2>
          <form>
            <div className="mb-3 row">
              {options.map(({ name: optionKey, options }) => (
                <div className="col-md-4" key={optionKey}>
                  <label htmlFor={optionKey} className="form-label">
                    {t(`lomavisCreator.aiAssistant.labels.${optionKey}`)}
                  </label>
                  <select
                    id={optionKey}
                    className="form-select"
                    defaultValue={profile[optionKey]}
                    onChange={(e) => {
                      dispatch(
                        updateAiAssistantProfileAttribute({
                          attribute: optionKey,
                          value: e.target.value === '0' ? null : e.target.value
                        })
                      );
                    }}
                  >
                    {options.map(({ key, label }) => (
                      <option key={key} value={key}>
                        {t(label)}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            </div>

          {fields.map((field) => (
            <div className="mb-3" key={field.id}>
              <label htmlFor={field.id} className="form-label">
                {t(field.label)}
              </label>
              {field.type === 'textarea' ? (
                <textarea
                  defaultValue={profile[field.id]}
                  id={field.id}
                  className="form-control"
                  onChange={(e) => {
                    dispatch(
                      updateAiAssistantProfileAttribute({
                        attribute: field.id,
                        value: e.target.value
                      })
                    );
                  }}
                  rows={field.rows}
                  placeholder={t(field.placeholder)}
                  maxLength={field.maxLength}
                ></textarea>
              ) : (
                <input
                  id={field.id}
                  type={field.inputType || 'text'}
                  className="form-control"
                  placeholder={t(field.placeholder)}
                  onChange={(e) => {
                    dispatch(
                      updateAiAssistantProfileAttribute({
                        attribute: field.id,
                        value: e.target.value
                      })
                    );
                  }}
                  defaultValue={profile[field.id]}
                />
              )}
              {/* Added help text with spacing */}
              {field.helpText && (
                <small className="form-text text-muted mb-2">
                  {t(field.helpText)}
                </small>
              )}
            </div>
          ))}
        </form>

        </div>
      </div>
    </div>
  );
};
